import axios from 'axios'
var _ = require('lodash')
const state = {
  currentPlaylist: {},
  userPlaylists: [],
  // courseLearned: {},
  loMasterData: [],
  allocatedVideos: [],
  numberOfPages: 0,
  currentPage: 0,
  singleConceptCollection: []
}
const getters = {
  getCurrentPage (state) {
    return state.currentPage
  },
  /* getAllocatedVideos (state) {
    return state.allocatedVideos
  }, */
  getUserSingleConceptsCollection (state) {
    // console.log('getting getUserSingleConceptsCollection')
    return state.singleConceptCollection
  },
  getNumberOfPages (state) {
    return state.numberOfPages
  },
  getcurrentPlaylist (state) {
    return state.currentPlaylist
  },
  getUserPlaylists (state) {
    return state.userPlaylists
  },
  getPlaylist: function (state) {
    return function (plId) {
      var currentPlaylist = null
      // state.userPlaylists.forEach(function (element) {
      _.forEach(state.userPlaylists, function (element) {
        if (element.plId === plId) {
          currentPlaylist = element
          return
        }
      })
      return currentPlaylist
    }
  },
  getLOMasterData: state => state.loMasterData,
  getLOObjectByItemId: (state, getters) => itemId => {
    for (var i = 0; i < getters.getCollectionList.length; i++) {
      if (getters.getCollectionList[i].contentId === itemId) {
        return getters.getCollectionList[i]
      }
    }
    // return state.currentPlayingcontent.path[0].filePath
  },
  getPlayListLOData: (state, getters) => playlist => {
    var result = []
    for (var i = 0; i < playlist.items; i++) {
      for (var j = 0; j < getters.getCollectionList.length; j++) {
        if (playlist.items[i] === getters.getCollectionList[i].contentId) {
          result.push(getters.getCollectionList[i])
        }
      }
    }
    return result
  },
  getLastPlayedContent: (state, getters) => contentId => {
    if (getters.getcurrentPlaylist.items !== null) {
      for (var i = 0; i < getters.getcurrentPlaylist.items.length; i++) {
        if (getters.getcurrentPlaylist.items[i].itemId === contentId) {
          return getters.getcurrentPlaylist.items[i].lastViewedDuration
        }
      }
    }
  }
}
const mutations = {
  resetPlayListDetailsPaginationDetailsInStore (state) {
    state.numberOfPages = 0
    state.currentPage = 0
    state.singleConceptCollection = []
  },
  clearPlaylistData (state) {
    state.userPlaylists = []
  },
  updatePlaylistItems (state, updatedPlaylist) {
    _.forEach(state.userPlaylists, function (playlist, index) {
      if (playlist.plId === updatedPlaylist.plId) {
        state.userPlaylists[index].items = updatedPlaylist.items
        return
      }
    })
  },
  appendPlaylist: (state, data) => {
    state.userPlaylists.push(data)
  },
  setCurrentPlaylist (state, data) {
    state.currentPlaylist = data
  },
  setUserPlaylists (state, data) {
    if (data !== null) {
      state.userPlaylists = data
    }
  },
  addItemInPlaylist (state, data) {
    // state.userPlaylists.forEach(function (element) {
    _.forEach(state.userPlaylists, function (element) {
      if (element.plId === data.plId) {
        element.items.push(data.item)
        return
      }
    })
    return
  },
  updatePlaylistItemDuration (state, data) {
    state.currentPlaylist.lastItemViewed.itemId = data.itemId
    state.currentPlaylist.lastItemViewed.itemViewedDuration = data.lastDuration
  },
  setLOMasterDataByPlaylist (state, data) {
    state.loMasterData = data
  },
  updatePlayListLastItemViewedByPlaylistId (state, data) {
    // console.log('>>>>>>>>', JSON.stringify(data))
    if (state.userPlaylists !== null) {
      for (var i = 0; i < state.userPlaylists.length; i++) {
        if (state.userPlaylists[i].plId === data.plId) {
          state.userPlaylists[i].lastItemViewed.itemId = data.itemId
          state.userPlaylists[i].lastItemViewed.lastViewedDuration = data.lastViewedDuration
          break
        }
      }
    }
  },
  SetUserSingleVideoCollectionInStore (state, data) {
    // console.log(' in mutation SetUserSingleVideoCollectionInStore')
    // console.log(JSON.stringify(data))
    // console.log(data.noOfPages)
    // console.log(data.collectionList)
    state.currentPage = JSON.parse(JSON.stringify(data.currentPage))
    if (data.noOfPages !== undefined) {
      state.numberOfPages = JSON.parse(JSON.stringify(data.noOfPages))
    }
    state.singleConceptCollection = JSON.parse(JSON.stringify(data.collectionList))
  }
}
const actions = {
  resetPlayListDetailsPaginationDetails (context) {
    context.commit('resetPlayListDetailsPaginationDetailsInStore')
  },
  getUserPlayList (context, data) {
    return new Promise((resolve, reject) => {
      window.axios
      .post('r/getAllPlaylists', data)
      .then(response => {
        context.commit('setUserPlaylists', response.data)
        resolve()
      })
      .catch(err => {
        console.log('ERROR_IN_FETCHING_PLAYLIST : ', err)
        reject(err)
      })
    })
  },
  addItemInPlaylist: (context, data) => {
    return new Promise((resolve) => {
      context.commit('addItemInPlaylist', data)
      resolve()
    })
  },
  setCurrentPlaylist (context, data) {
    context.commit('setCurrentPlaylist', data)
  },
  removePlayListFromDb (context, data) {
    window.axios
    .post('r/deletePlayListItem', data)
    .then(response => {
      context.commit('setUserPlaylists', response.data)
    })
  .catch(err => {
    console.log(err)
  })
  },
  createPlaylist (context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post('r/createPlayList', data)
        .then(response => {
          context.commit('appendPlaylist', response.data)
          resolve(response.data)
          // context.commit('setUserPlaylists', response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  daletePlaylist (context, data) {
    window.axios
  .post('r/deletePlayList', data)
  .then(response => {
    context.commit('setUserPlaylists', response.data)
  })
  .catch(err => {
    console.log(err)
  })
  },
  updatePlaylistItemDuration (context, data) {
    return new Promise((resolve) => {
      context.commit('updatePlaylistItemDuration', data)
      resolve()
    })
  },
  setLOMasterDataByPlaylist (context, data) {
    context.commit('setLOMasterDataByPlaylist', data)
  },
  updatePlayListLastItemViewedByPlaylistId (context, data) {
    context.commit('updatePlayListLastItemViewedByPlaylistId', data)
  },
  // fetchUserSingleConceptCollection - fetch the user single concepts collection page wise
  fetchUserSingleConceptCollection (context, data) {
    return new Promise((resolve, reject) => {
      axios
      .post('o/getUserSingleConceptsCollection', {'profileId': data.profileId, 'pageNo': data.pageNo})
      .then(res => {
        if (data.pageNo === 1) {
          res.data['collectionList'] = JSON.parse(JSON.stringify(res.data.collectionList))
          res.data['currentPage'] = context.getters.getCurrentPage + 1
          context.commit('SetUserSingleVideoCollectionInStore', res.data)
          resolve(res)
        } else {
          // console.log('append result to data')
          // var playList = JSON.parse(JSON.stringify(context.getters.getUserSingleConceptsCollection))
          var userSingleConceptCollection = {}
          var singleConceptPlayList = JSON.parse(JSON.stringify(context.getters.getUserSingleConceptsCollection))
          for (let i = 0; i < res.data.collectionList.length; i++) {
            singleConceptPlayList.push(res.data.collectionList[i])
          }
          // userSingleConceptCollection['collectionList'] = JSON.parse(JSON.stringify(context.getters.getUserSingleConceptsCollection)).concat(JSON.parse(JSON.stringify(res.data.collectionList)))
          // console.log('singleConceptPlayList ::: ', JSON.stringify(singleConceptPlayList))
          userSingleConceptCollection['collectionList'] = singleConceptPlayList
          userSingleConceptCollection['currentPage'] = context.getters.getCurrentPage + 1
          context.commit('SetUserSingleVideoCollectionInStore', userSingleConceptCollection)
        }
      })
      .catch(err => {
        console.log('error in fetching user collection : ', err)
        reject()
      })
    })
  },
  getSingleConceptSearchResult (context, data) {
    return new Promise((resolve, reject) => {
      //   axios
      //   .post(/')
      //   .then()
      //   .catch()
      resolve()
    })
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/playList.js